module.exports = __webpack_public_path__ + "static/img/watercrafts-on-river-3464632.d43fa665.jpg";